import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-modal-header",
  templateUrl: "./modal-header.component.html",
  styleUrls: ["./modal-header.component.sass"],
})
export class ModalHeaderComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
